module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_concept_01-0815c074131382fa732032d5b4b5192e.jpg";